import gql from 'graphql-tag';

export default gql`
  mutation favoriteAddItem($id: ID!) {
    favoriteAddItem(id: $id) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
